import { gql } from "apollo-boost";

const banners = gql`
  query ($filter: BannerFilter) {
    banners(filter: $filter) {
      total
      items {
        id
        type
        state
        note
        startTime
        endTime
        createDate
        communityIds
        eduShareOffer {
          id
          title
          summary
          price
          originalPrice
        }
      }
    }
  }
`;

const banner = gql`
  query banner($id: id!) {
    banner(id: $id) {
      id
      type
      state
      note
      startTime
      endTime
      createDate
      communityIds
      eduShareOffer {
        id
        title
        summary
        price
        originalPrice
      }
    }
  }
`;

const saveBanner = gql`
  mutation saveBanner($input: BannerInput!) {
    saveBanner(input: $input)
  }
`;

const delBanner = gql`
  mutation delBanner($id: String!) {
    delBanner(id: $id)
  }
`;

export const bannerGql = {
  banners,
  banner,
  saveBanner,
  delBanner,
};
